import React, { FC, memo, useEffect } from "react";
import dynamic from "next/dynamic";
import { ActionBar } from "@/components/ActionBar/ActionBar";
import { SharedText } from "@/components/SharedText/SharedText";
import { LazyHydrateContainer } from "@/hoc/LazyHydrate";
import { useAuth } from "@/hooks/auth";
import { useCart } from "@/hooks/cart/cart";
import { useModals } from "@/hooks/modals/useModals";
import { modalsAlias } from "@/store/reducers/commonSlice";
import { cssIsActive, cssSup, HeadingRow, HeadingStep, HeadingSteps, PageHeading } from "@/styles/utils/Utils";
import { colors } from "@/styles/utils/vars";
import { Button } from "@/ui/Button/Button";
import { CheckoutButtonGroup } from "@/ui/Button/StyledButton";
import { Icon } from "@/ui/Icon";
import { Link } from "@/ui/Link";
import { Span, Typography } from "@/ui/Typography/Typography";
import { ROUTES } from "@/utils/constants";
import { Provider as PrintCartProvider, usePrintCart } from "../Print";
const Print = dynamic(() => import("../Print").then(c => c.Print), {
  ssr: false
});
const Header: FC = memo(() => {
  const {
    runPrint,
    enabled: enabledPrint,
    resetPrint,
    isLoading: isLoadingPrint
  } = usePrintCart();
  const {
    clearCart,
    setIsShowShare,
    shareCart,
    sharePath,
    isShowShare,
    isEmpty,
    cartCount
  } = useCart();
  const {
    show: showModal
  } = useModals();
  const {
    isAuth
  } = useAuth();
  useEffect(() => {
    return () => {
      console.log("cleanup resetPrint");
      resetPrint();
    };
  }, []);
  return <PageHeading>
      <HeadingSteps>
        <HeadingStep className={cssIsActive}>
          Корзина {!!cartCount && <Span className={cssSup}>{cartCount}</Span>}
        </HeadingStep>
        <Icon NameIcon={"ArrowCircleRight"} />
        <HeadingStep>
          <Link href={ROUTES.checkout}>Оформление заказа</Link>
        </HeadingStep>
      </HeadingSteps>

      {!isEmpty && <CheckoutButtonGroup justifyContent={"flex-end"}>
          <Button variant={"link"} icon={"Print"} onClick={runPrint} isFetching={isLoadingPrint}>
            Напечатать
          </Button>

          <Button variant={"link"} icon={"Share"} onClick={shareCart}>
            Поделиться корзиной
          </Button>

          {!!sharePath && <SharedText share={{
        url: sharePath,
        title: "С Вами поделились корзиной"
      }} isShowed={isShowShare} setIsShowed={setIsShowShare} />}

          <Button variant={"link"} icon={"Delete"} onClick={clearCart}>
            Очистить корзину
          </Button>
        </CheckoutButtonGroup>}

      {!isEmpty && !isAuth && <ActionBar variant={"red"} icon={"Warning"} iconSize={"default"} description={<Typography style={{
      color: colors.black
    }}>
              <Button variant={"link"} as={"a"} onClick={() => {
        showModal({
          alias: modalsAlias.auth
        });
      }}>
                Авторизуйтесь
              </Button>
              , чтобы сохранить корзину для просмотра на этом и других
              устройствах или в мобильном приложении.
            </Typography>} />}

      {enabledPrint && <LazyHydrateContainer>
          <HeadingRow>
            <Print />
          </HeadingRow>
        </LazyHydrateContainer>}
    </PageHeading>;
});
Header.displayName = "HeaderCart";
const HeaderWithProviders: FC = props => {
  return <PrintCartProvider>
      <Header {...props} />
    </PrintCartProvider>;
};
export { HeaderWithProviders as Header };